<template>
  <el-menu default-active="1">
    <el-menu-item index="1">每日歌单</el-menu-item>
    <!-- <el-menu-item index="2">每周精选</el-menu-item> -->
    <!-- <el-menu-item index="3">每月精选</el-menu-item> -->
  </el-menu>
</template>

<script>
import { Menu, MenuItem } from 'element-ui'

export default {
  name: 'AdminMenu',
  components: {
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/admin/AdminMenu.vue